module.exports = __webpack_public_path__ + "static/media/YourLonelyNightsareOver.8ce6bca7.jpg";